import { composeFieldPath } from '@northfork/basics'
import { TransactionTypeKey } from '../../transaction-type.model'
import { BulkExternalData } from '../bulk-misc-model'
import { TransactionTypeLabel } from '../bulk-transaction'

export const fxForwardField = composeFieldPath([] as BulkFxForwardRow[])
export const fxSpotField = composeFieldPath([] as BulkFxSpotRow[])

export type FXSpotType = {
  label: string
  type: 'FXS' | 'FXF'
  tranType: TransactionTypeKey
}

export interface BulkFxForwardRow extends BulkExternalData {
  rowId: string
  rowNumber?: string
  createDate?: string
  account: string
  entryDate: string
  settleDate: string
  fromSecurityCusip: string
  toSecurityCusip: string
  fromUnits: string
  toUnits: string
  counterParty: string
  validityStatus: 'valid' | 'invalid' | 'warning' | 'inactive' | 'intermediate'
  errorMessageMap: Map<string, string[]>
  legacyOrigTranId?: number
  sleeveAccountId?: number
  orderId?: string
  transactionTypeLabel?: TransactionTypeLabel
  cleared: boolean
}

export interface BulkFxSpotRow extends BulkExternalData {
  rowId: string
  rowNumber?: string
  account: string
  entryDate: string
  settleDate: string
  tranType: string
  fromSecurityId: string
  toSecurityId: string
  fromUnits: string
  sellToBuyUnitRatio?: string
  toUnits: string
  buyToSellUnitRatio?: string
  counterParty: string
  validityStatus: 'valid' | 'invalid' | 'warning' | 'inactive' | 'intermediate'
  errorMessageMap: Map<string, string[]>
  legacyOrigTranId?: number
  sleeveAccountId?: number
  orderId?: string
  transactionTypeLabel?: TransactionTypeLabel
}
